import React, { useState, useEffect } from 'react';
import { makeStyles, Button, TextField } from '@material-ui/core';
import {toDateFormatWithT} from '../../Helpers/dateHelper'
import { useTranslation } from 'react-i18next';

export default function OrderStartEndDateComponent(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        props.start?
        <React.Fragment>
            <div className={classes.planningTitle}>
                Planning
            </div>
            <div className={classes.dates}>
                <div className={classes.from}>
                    <div className={classes.fromtill}>
                        {t("From")}
                    </div>
                    <div>
                            <TextField className={classes.datePicker}
                                id="datetime-local"
                                variant="outlined"
                                type="datetime-local"
                                format="dd-MM-yyyy HH:mm"
                                onChange={date => props.handleFromDateChange(date)}
                                size='small'
                                value={toDateFormatWithT(props.start)}                               
                            />
                    </div>
                </div>
                <div className={classes.till}>
                    <div className={classes.fromtill}>
                        {t("Till")}
                    </div>
                    <div>
                            <TextField className={classes.datePicker}                                
                                id="datetime-local"
                                variant="outlined"
                                type="datetime-local"
                                format="dd-MM-yyyy HH:mm"
                                onChange={date => props.handleTillDateChange(date)}
                                size='small'
                                value={toDateFormatWithT(props.end)}                               
                            />
                    </div>
                </div>
            </div>
        </React.Fragment>: <React.Fragment></React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    planningTitle: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        display: "block",
        textAlign: "left",
        marginBottom: "10px"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
    },
    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },
    from: {
        width: "50%",
        float: "left",
    },
    till: {
        width: "50%",
        float: "left",
    },
    dates: {
        weight: "100%",
        height: "50px"
    }

}));